export function useFaq() {
  const config = useRuntimeConfig()
  const locale = useI18n().locale

  return useAsyncData(
    () => `faq-${locale.value}`, // unique key per locale. will cache and only recache on locale change
    async () => {
      const story = await useAsyncStoryblok('pages/faq', {
        version: config.public.storyblokVersion,
        language: locale.value.replace('de', 'de_CH'),
      })
      return story.value?.content?.questions ?? []
    }
  )
}
